import 'jquery';

// Google Material Forms Javascript instantiation
// import {MDCTextField} from '@material/textfield';
// const textField = new MDCTextField(document.querySelector('.mdc-text-field'));

// // Smooth Scrolling
// import './misc/smooth-scrolling'

// Debounce
// import './misc/debounce'

// Debounce
// import './misc/header-headroom-style'
// import './misc/header'

// Cursor Follower
// import './misc/cursor-follower'

// Font Awesome
// import './misc/font-awesome'

// Header
// import './misc/header'

// Navigation - Large
// import './misc/header-navigation-large'

// Navigation - Small
// import './misc/header-navigation-small'

// Quick Contact
// import './misc/search'

// FacetWP Sort Config
// import './misc/facetwp-sort'

// Share
// import './misc/share'

// Notification Bar
// import './misc/notification-bar'

// Form Popup
// import './misc/form-modal'

// Blocks
// import './blocks/background-video'

// Block - Accordion
// import './blocks/block-accordion';

// Block - Tabs
// import './blocks/block-tabs';

// Block - Button
// import './blocks/block-button';

// Block - Anchor Navigation Bar
// import './blocks/block-anchor-navigation-bar';

// // BAD IDEA
// // Block - Content Group (Nested)
// import './blocks/BAD-block-content-group-nested'

// Block - Content Group - Internal Block Width
// import './blocks/content-group-children-width-mod-for-gap'

// Block - Video
// import './blocks/block-video';
// import './blocks/testimonials';

// Block - Testimonials (Swiper carousel)
import '../../views/blocks/testimonials/testimonials';

// Block - Google Map
import './blocks/block-google-map';

// Pattern - Anchor Navigation
// import './components/anchor-navigation';

// Block - Carousel - 'Swiper'
// import './blocks/block-carousel-initialize';

// Block - Fader - 'Swiper'
// import './blocks/block-fader-swiper';

// Block - Modal
// import './blocks/block-modal';



// Effects - Parallax
// Block Section - Background Image
// import './blocks/effects/block-section-parallax';

// Block Image - Background Image
// import './blocks/effects/block-image-parallax';



// Reveal Animations
// Fade In - Content Group
// import './blocks/animation-block-content-group';

// Fade In - Blocks
// Code doesn't exist yet.

// Effect 1 - Image Block & Video Block
// import './blocks/reveal-animations/reveal-animation-effect-1';

// Number Count - Heading Block
// import './blocks/reveal-animations/reveal-animation-number-count';

// Rise - Heading Block
// import './blocks/reveal-animations/reveal-animation-rise';

// Page Routes
// Home Page
// import './pages/home-intro-animation';

// News Archive
// import './pages/news-archive';

// Body Part Claims Graphic
// import './pages/body-part-claims';

// Block - Stats counter animation
import './blocks/stats';

// Block - Service Grid Modal
import './blocks/service-modal';

// Block fade-in on scroll
import './blocks/block-animations';

// Counting Number Cards
import './blocks/counting-number-cards'

// Image Cards Carousel
// import './blocks/patterns/image-cards-carousel'
// import './blocks/patterns/image-cards-carousel-overlay'

// Team Grid
// import './blocks/patterns/team-grid'


// /*
// -----------------------------------------------
// // Full Width Image With Left Offset
// -----------------------------------------------
// */
// function fullWidthImageWithLeftOffset() {
//     const containerInternal = $('.hero .container-internal');
//     const leftOffset = $(containerInternal).offset().left;
//     const fullWidthImage = $('.block-image.full-width-with-left-offset');
//
//     // console.log("Containter Internal Left Offset: " + leftOffset);
//
//     $(fullWidthImage).css('padding-left', leftOffset);
// }
//
// fullWidthImageWithLeftOffset();
//
// $(window).resize(function() {
//     fullWidthImageWithLeftOffset();
// });



/*
-----------------------------------------------
// Fix Translate options
-----------------------------------------------
*/

function fixLanguageOptions() {

  let languageButton = jQuery('.language-button');
  languageButton.find('span.temp').show();
  languageButton.find('span.dropdown').hide();

  setTimeout(function () {

      languageButton.find('option').each(function () {
          let html = jQuery(this).html();
          //console.log(html);
          switch (html) {
              case 'Select Language' :
                  jQuery(this).html('Language');
                  break;

              case 'Chinese (Traditional)' :
                  jQuery(this).html('Chinese');
                  break;

              default :
                  break;
          }

          languageButton.find('span.temp').hide();
          languageButton.find('span.dropdown').show();
          //languageButton.find('select').attr('id', 'language');
      });
  }, 1000);
}

jQuery(document).ready(function () {
    fixLanguageOptions();

    let languageButton = jQuery('.language-button');

    languageButton.change(function () {
        fixLanguageOptions();
    });
});

document.querySelector('.hero-anchor')?.addEventListener('click', function (e) {
  e.preventDefault();

  const hero = document.querySelector('.hero-screen');
  if (!hero) return;

  const targetOffset = hero.offsetHeight;
  const start = window.scrollY;
  const end = start + targetOffset;
  const duration = 1000; // ms

  const easeInOutQuad = (t) =>
    t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

  let startTime = null;

  function animateScroll(currentTime) {
    if (!startTime) startTime = currentTime;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = easeInOutQuad(progress);

    window.scrollTo(0, start + (end - start) * ease);

    if (elapsed < duration) {
      requestAnimationFrame(animateScroll);
    }
  }

  requestAnimationFrame(animateScroll);
});
